// Zentrale i18n-Konfiguration.
// Deutsch lebt an der URL-Wurzel (bestehende URLs bleiben stabil),
// Englisch unter /en. Muster: wiki tech/nextjs-seo-indexing.
export const LANGS = ['de', 'en'] as const;
export type Lang = (typeof LANGS)[number];
export const DEFAULT_LANG: Lang = 'de';

export function isLang(value: string): value is Lang {
  return (LANGS as readonly string[]).includes(value);
}

/** Externer URL-Pfad für eine Sprache: de ohne Präfix, en mit /en. */
export function localePath(lang: Lang, path: string): string {
  const clean = path === '/' ? '' : path;
  return lang === 'de' ? (clean || '/') : `/en${clean}`;
}

/** Entfernt ein /en-Präfix aus einem externen Pfad. */
export function stripLangPrefix(pathname: string): { lang: Lang; path: string } {
  if (pathname === '/en' || pathname.startsWith('/en/')) {
    return { lang: 'en', path: pathname.slice(3) || '/' };
  }
  // Defensive: interne /de-Pfade (Middleware-Rewrite) ebenfalls strippen
  if (pathname === '/de' || pathname.startsWith('/de/')) {
    return { lang: 'de', path: pathname.slice(3) || '/' };
  }
  return { lang: 'de', path: pathname };
}

export const HTML_LANG: Record<Lang, string> = { de: 'de', en: 'en' };
export const OG_LOCALE: Record<Lang, string> = { de: 'de_DE', en: 'en_US' };
export const IN_LANGUAGE: Record<Lang, string> = { de: 'de-DE', en: 'en-US' };
